import React, { Component } from "react";

class CallUs extends Component {
  render() {
    return (
      <div>
        <div className="dr">
          <input type="checkbox" id="dr-tr1" className="dr-tr a11y--h" />
          <label for="dr-tr1" className="dr-h">
            <h2 className="sh-title">Business Hours</h2>
            <p className="dr-st">5:00AM OPEN MONDAY - FRIDAY</p>
          </label>
          <div className="dr-c">
            <div className=" t--intro">
              <h5 style={{ display: "inline-block" }}>
                {" "}
                For orders please click here to call:{" "}
              </h5>
              <a className="dr-st t--intro" href="tel:1-508-784-7488">
                {" "}
                508-784-7488
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CallUs;
